import { render, staticRenderFns } from "./WorkingDraftHelp.vue?vue&type=template&id=1f6a2c4c&scoped=true"
import script from "./WorkingDraftHelp.vue?vue&type=script&lang=js"
export * from "./WorkingDraftHelp.vue?vue&type=script&lang=js"
import style0 from "./WorkingDraftHelp.vue?vue&type=style&index=0&id=1f6a2c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6a2c4c",
  null
  
)

export default component.exports